

import React, {    } from 'react';
import {  Container,Row  } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import styled from "styled-components";
import DeviceUtils from "../../../helper/DeviceUtils";

import { Icon } from 'semantic-ui-react';
import se from "../../../images/homepage/se.png";


const Centeryellow =  styled.div` 
    color:white;
    padding-top: ${props => props.paddingTop}px;
    background-color: #4890cb;
    height: ${props => props.height}px;
    position: relative;  `;

const H4div =  styled.span` 
    font-size: ${props => props.fontSize}px ;
        line-height:1em;  `;


const ServicesCenteryellowView = () => {

    const IconViewClass = (DeviceUtils.isMobile()===true)?"col-12 text-center":"col-4 text-center";

    const yellowPlusSize = (DeviceUtils.isMobile()===true)?25:35;

    return (<Centeryellow paddingTop={(DeviceUtils.isMobile()===true)?25:40}  height={(DeviceUtils.isMobile()===true)?100:170}  >
        <Container>
            <Row>

                <Container >
                    <Row>
                        <div className='col-12 mt-2'>
                            <H4div>
                                {/*<Icon name='plus' color='black'  size='huge'  style={{fontSize:`${yellowPlusSize}pt`}}/>*/}
                                <H4div className="mainColor mt-2  " style={{fontFamily: 'Impact, Charcoal, sans-serif'}} fontSize={(DeviceUtils.isMobile()===true)?35:60} >
                                   {(DeviceUtils.isMobile()===true)?<img height={45} src={se}/>:'Services'}
                                </H4div>
                            </H4div>
                        </div>
                    </Row>
                </Container>

            </Row>
        </Container>

    </Centeryellow>);
};

export default ServicesCenteryellowView;



// WEBPACK FOOTER //
// ./src/components/homepage_new/services/ServicesCenteryellowView.js